"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarcodeTranslationHack = void 0;
exports.BarcodeTranslationHack = {
    NO_TRANSLATION: "NO_TRANSLATION",
};
//# sourceMappingURL=barcode-translation-hack.js.map